import { Roles } from "@/models/user/roles";
import { PartialNetSuiteCustomer, PriceLevel } from "@/models/netsuite/netsuite";
import { SSOImpersonation } from "@/services/auth_service";
import { GlobalState } from "./types";

export const getLoading = (state: GlobalState): boolean => {
  return state.isLoading;
};

export const getLoggedIn = (state: GlobalState): boolean => {
  return state.isLoggedIn;
};

export const getRole = (state: GlobalState): Roles | null => {
  return state.userRole;
};

export const getMobile = (state: GlobalState): boolean => {
  return state.isMobile;
};

export const getTablet = (state: GlobalState): boolean => {
  return state.isTablet;
};

export const getMultiplier = (state: GlobalState): PriceLevel | null => {
  return state.multiplier;
};

/**
 * FUPOF-191: only levels a quote line can actually be submitted at.
 *
 * `get_price_levels` returns the whole NetSuite PriceLevel table, which includes the
 * built-in "Custom" level (internal id -1). Custom is not a multiplier — it is the
 * sentinel for "the caller supplies the rate", so it sources nothing from an item's
 * pricing matrix and a line submitted at it reaches NetSuite with a blank amount,
 * failing the whole estimate save. Filtering here keeps it out of the multiplier
 * dropdown and out of every customer/quote level lookup in one place; callers that
 * miss on a lookup already fall back to Base Price (id 1), which IS x1.
 */
export const getPriceLevels = (state: GlobalState): PriceLevel[] => {
  return state.priceLevels.filter(
    level => typeof level.id === "number" && level.id > 0
  );
};

export const getCustomers = (state: GlobalState): PartialNetSuiteCustomer[] => {
  return state.customers;
};

export const getAuthToken = (state: GlobalState): string | null => {
  return state.authToken;
};

export const getImpersonation = (state: GlobalState): SSOImpersonation | null => {
  return state.impersonation;
};
